import { defineComponent as _defineComponent } from 'vue'
import GeoJSON from 'geojson'
import { useMap } from '../mapbox/context'
import { onBeforeMount, onUnmounted, provide, watch } from 'vue'

type DataType =
  | GeoJSON.Feature<GeoJSON.Geometry>
  | GeoJSON.FeatureCollection<GeoJSON.Geometry>
  | string


export default /*#__PURE__*/_defineComponent({
  __name: 'GeoJsonSource',
  props: {
    sourceId: null,
    data: null,
    cluster: { type: Boolean },
    clusterMaxZoom: null,
    clusterRadius: null,
    clusterProperties: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  sourceId: string
  // Due to Vue <= 3.2 limitation, it's not possible to declare a props with custom type imported from another file
  // In this case, `data` should be of type
  // GeoJSON.Feature<GeoJSON.Geometry>| GeoJSON.FeatureCollection<GeoJSON.Geometry> | string
  // When we upgrade to Vue 3.3, we could change it back
  // https://github.com/vuejs/core/discussions/6737
  data:
    | object // GeoJSON.Feature<GeoJSON.Geometry> | GeoJSON.FeatureCollection<GeoJSON.Geometry>
    | string
  cluster?: boolean
  clusterMaxZoom?: number
  clusterRadius?: number
  clusterProperties?: object
}

const { map } = useMap()



const setDataSource = (data: DataType) => {
  const source = map.value?.getSource(props.sourceId)

  if (data && source && source.type === 'geojson') {
    source.setData(data)
  } else {
    // map.addSource has some weird issues with passing in undefined
    // for some property values. JSON.parse/stringify loses the
    // undefined properties, and solves that issue.
    map.value?.addSource(
      props.sourceId,
      JSON.parse(
        JSON.stringify({
          type: 'geojson',
          data: data,
          buffer: 0,
          cluster: props.cluster ?? false,
          clusterMaxZoom: props.clusterMaxZoom,
          clusterRadius: props.clusterRadius,
          clusterProperties: props.clusterProperties,
        })
      )
    )
  }
}

onBeforeMount(() => {
  setDataSource(props.data as DataType)
})

watch(
  () => props.data,
  (d) => setDataSource(d as DataType)
)

const refreshData = () => {
  const source = map.value?.getSource(props.sourceId)
  if (source && source.type === 'geojson') {
    source.setData(props.data as DataType)
  }
}

onUnmounted(() => {
  map.value?.removeSource(props.sourceId)
})

provide('source', props.sourceId)

expose({ refreshData })

return { __sfc: true,map, props, setDataSource, refreshData }
}

})